
import { defineComponent, onMounted } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import OVIAdvisory from "@/views/OVIAdvisory.vue";
import ECShopAdvisory from "@/views/ECShopAdvisory.vue";
import SealProEncode from "@/views/modals/SealProEncode.vue";
import SealProAutoCoverage from "../modals/SealProAutoCoverage.vue";
import { getCurrentUser } from "@/utils/index";
import { getDashboardData } from "@/api/dashboard";
import { settingsdata } from "@/api/settings";
import OVISequenceOverview from "@/components/dashboard/sequence/OVISequenceOverview.vue";
import DashboardProfileHeader from "@/components/dashboard/DashboardProfileHeader.vue";

interface DashboardUser {
  avatar?: string;
  fname?: string;
  lname?: string;
  usid?: string;
  address?: string;
  email?: string;
}

export default defineComponent({
  name: "DashboardOVI",
  components: {
    SealProEncode,
    OVIAdvisory,
    ECShopAdvisory,
    SealProAutoCoverage,
    OVISequenceOverview,
    DashboardProfileHeader,
  },
  data() {
    return {
      user: {} as DashboardUser,
      dashboarddata: {} as Record<string, unknown>,
      allowClose: true,
      inputActivationDetail: false,
      allowChangeName: true,
      encode_now_sealpro_key: 0,
      encode_now_sealproautocoverage_key: 0,
      firstCoverage: {} as Record<string, unknown>,
      rankPrimeImage: "",
      rankPrime: "",
      currentRank: "",
      showRankImage: true,
      loading: true,
      loadError: false,
      echequeUrl: "",
      echequeUrlNoError: true,
      showEChequeImage: false,
      coverPhoto: "media/cover/unstoppabull.png",
    };
  },
  setup() {
    onMounted(() => {
      setCurrentPageTitle("Dashboard");
    });
  },
  methods: {
    async loadDashboard() {
      this.loading = true;
      this.loadError = false;

      try {
        const response = await getDashboardData();
        const data = response?.data;

        if (!data) {
          this.loadError = true;
          return;
        }

        this.dashboarddata = data;
        this.echequeUrl = data.echequeUrl ?? "";
        this.showEChequeImage = Boolean(data.showEChequeImage);
        this.applyRankImage(data);

        if (data.isOviSealProformActive) {
          let allowChangeName = false;
          if (
            data.firstCoverage != null &&
            data.firstCoverage.coverage_transtype === "IMMEDIATE"
          ) {
            allowChangeName = true;
          }
          this.firstCoverage = data.firstCoverage ?? {};
          this.encodeSealProNow(allowChangeName);
        } else if (data.isOviSealProAutoCoverageFormActive) {
          this.encodeSealProAutoCoverageNow();
        }
      } catch (error) {
        console.error("Failed to load OVI dashboard data:", error);
        this.loadError = true;
      } finally {
        this.loading = false;
      }
    },
    applyRankImage(data: Record<string, unknown>) {
      const rankPrime = data.rankPrime as string | undefined;
      const currentRank = data.currentRank as string | undefined;

      this.rankPrime = rankPrime ?? "";
      this.currentRank = currentRank ?? "";

      if (rankPrime === "SEP" || rankPrime === "GEP" || rankPrime === "GAP") {
        this.rankPrimeImage = `media/rank_logos/${rankPrime}_header.png`;
        this.showRankImage = true;
        return;
      }

      if (currentRank && currentRank !== "DI") {
        this.rankPrimeImage = `media/rank_logos/${currentRank}_header.png`;
        this.showRankImage = true;
      } else {
        this.showRankImage = false;
      }
    },
    addAccount() {
      this.allowClose = true;
      this.inputActivationDetail = false;
      this.allowChangeName = false;

      setTimeout(() => {
        const btn = this.$refs.addAccountModalButton as HTMLButtonElement | undefined;
        btn?.click();
      }, 500);
    },
    encodeSealProNow(allowChangeName: boolean) {
      this.allowChangeName = allowChangeName;
      this.encode_now_sealpro_key += 1;
      setTimeout(() => {
        const btn = this.$refs.encodeNowSealproModalButton as HTMLButtonElement | undefined;
        btn?.click();
      }, 500);
    },
    encodeSealProAutoCoverageNow() {
      this.encode_now_sealproautocoverage_key += 1;
      setTimeout(() => {
        const btn = this.$refs.encodeNowSealproAutoCoverageModalButton as HTMLButtonElement | undefined;
        btn?.click();
      }, 500);
    },
    async loadCoverPhoto() {
      try {
        const response = await settingsdata();
        if (response?.data?.coverPhotoUrl) {
          this.coverPhoto = response.data.coverPhotoUrl;
        }
      } catch (error) {
        console.error("Failed to load cover photo:", error);
      }
    },
  },
  mounted() {
    this.user = getCurrentUser() ?? {};
    this.loadDashboard();
    this.loadCoverPhoto();
  },
  computed: {
    lifetimeIncome(): number | string {
      const details = this.dashboarddata.lifetimeincomedetails as
        | Record<string, unknown>
        | undefined;
      if (!details) {
        return 0;
      }
      return (details.income ?? details.INCOME ?? 0) as number | string;
    },
    lifetimeCurrency(): string {
      const details = this.dashboarddata.lifetimeincomedetails as
        | Record<string, unknown>
        | undefined;
      return String(
        details?.curr ?? details?.CURR ?? this.dashboarddata.currency ?? ""
      );
    },
  },
});
